import type { Episode } from '@/domain/episode'
import type { EpisodeFilter, EpisodeRepository } from '@/repositories/EpisodeRepository'
import { seedEpisodes } from '@/data/seed/episodes'

// Zero-cost implementation of EpisodeRepository, backed by seed data
// (Document 11 §4). CosmosEpisodeRepository (P5) implements the same
// interface against the production Episode/Quiz Service.
export class LocalEpisodeRepository implements EpisodeRepository {
  async list(filter?: EpisodeFilter): Promise<Episode[]> {
    let items = seedEpisodes.filter((e) => e.cmsStatus === 'published')
    if (filter?.topicTag) {
      items = items.filter((e) => e.topicTags.includes(filter.topicTag!))
    }
    if (filter?.difficulty) {
      items = items.filter((e) => e.difficulty === filter.difficulty)
    }
    if (filter?.search) {
      const q = filter.search.toLowerCase()
      items = items.filter(
        (e) => e.title.toLowerCase().includes(q) || e.synopsis.toLowerCase().includes(q)
      )
    }
    return items
  }

  async getById(id: string): Promise<Episode | null> {
    return seedEpisodes.find((e) => e.id === id) ?? null
  }
}
